import React, { useState, useEffect } from 'react';
import { ToolTipWrapper } from 'common/components';
import { NUMBER_ARRAY } from 'common/global/constants';

export function EllipsisTypography({
  title,
  TypographyElement,
  maxWidth = NUMBER_ARRAY.zero,
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const getTextWidth = (text, font) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
  };


  useEffect(() => {
    let textWidth = getTextWidth(title || '', '16px JohnsonText-Regular');
    if (textWidth && textWidth > maxWidth) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  }, [title]);

  if (showTooltip) {
    return (
      <ToolTipWrapper placement='top' header='' title={title} isOnlyText={true}>
        {TypographyElement}
      </ToolTipWrapper>
    );
  }
  return TypographyElement;
}
